var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconHumanResourcesWorkflow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.749 9.75a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 1 0-4.5 0Zm6 6a4.047 4.047 0 0 0-3.75-3 4.047 4.047 0 0 0-3.75 3m1.875-13.125a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 1 0-3.75 0ZM19.499 12a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 1 0-3.75 0Zm-9.375 9.375a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 1 0-3.75 0ZM.749 12a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 1 0-3.75 0ZM16.5 4.2a9.041 9.041 0 0 1 3.3 3.3m0 9a9.041 9.041 0 0 1-3.3 3.3m-9 0a9.041 9.041 0 0 1-3.3-3.3m0-9a9.041 9.041 0 0 1 3.3-3.3",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconHumanResourcesWorkflow);
export default __webpack_public_path__ + "static/media/streamline-icon-human-resources-workflow.4f481e63.svg";
export { ForwardRef as ReactComponent };